import React from 'react';

export default function IconMinus(props) {
	return (
		<svg width="9" height="9" viewBox="0 0 9 9" {...props}>
			<rect y="4" width="9" height="1" fill="currentColor" />
		</svg>
	);
}
